import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Box } from "@mui/material";
import Assessment from "../views/assessments/Assessment";
import AssessmentHistory from "../views/assessments/AssessmentHistory";
import AboutAssessment from "../views/LearnMore/AboutAssessment";
import DentalStatus from "../views/LearnMore/DentalStatus";
import GlobalJudgments from "../views/LearnMore/GlobalJudgments";
import BodyAreas from "../views/LearnMore/BodyAreas";
import Header from "../views/assessments/Header";
import Patient from "../views/patient/Patient";
import AddPatient from "../views/patient/AddPatient";
import BottomBar from "../views/assessments/BottomBar";
import AssessmentSaveAndExit from "../views/assessments/AssessmentSaveAndExit";
import { useAssessmentSaveAndExit } from "../providers/AssessmentSaveAndExitProvider";
import AssessmentResult from "../views/assessments/AssessmentResult";
import { useLoader } from "../providers/LoaderProvider";
import Loader from "../components/Loader";
import { useAssessmentWalkthrough } from "../providers/AssessmentWalkthroughProvider";
import AssessmentWalkthrough from "../views/assessments/AssessmentWalkthrough";
import GuidedModeSelectionScreen from "../views/assessments/ExpertModeAssessment/GuidedModeSelectionScreen";
import { useGuidedMode } from "../providers/GuidedModeProvider";

const useStyle = () => {
  return {
    rootGrid: {
      minHeight: "100vh",
      minWidth: "300px",
      display: "grid",
      gridTemplateRows: "auto 1fr auto",
      gridTemplateColumns: "100%",
    },
    layoutContainer: {
      overflowX: "auto",
      width: "100%",
      margin: "0 auto",
      padding: { xs: "0 10px 40px 10px", md: "0 20px 30px 20px" },
    },
  };
};

function AppLayout() {
  const { loader } = useLoader();
  const { showWalkthroughDialog, showCheckBox, showIsMobileWalkthroughDialog } =
    useAssessmentWalkthrough();
  const { showGuidedModeDialog } = useGuidedMode();

  const checkIsAssessmentScreen = (location) => {
    location = location.substring(1);
    location = location.split("/");
    let assessment = location[2];
    let history = location[location.length - 1];
    if (
      assessment === "assessment" &&
      !location.includes("result") &&
      history !== "history"
    ) {
      return true;
    } else {
      return false;
    }
  };
  let location = useLocation();
  const isAssessmentScreen = checkIsAssessmentScreen(location.pathname);
  const styles = useStyle();
  let { showSaveAndExitModal } = useAssessmentSaveAndExit();
  return (
    <>
      {loader && <Loader />}
      {showGuidedModeDialog && <GuidedModeSelectionScreen />}
      {!showGuidedModeDialog && showWalkthroughDialog && (
        <AssessmentWalkthrough showCheckBox={showCheckBox} />
      )}
      {showSaveAndExitModal && <AssessmentSaveAndExit />}
      <Box sx={styles.rootGrid}>
        {isAssessmentScreen ? <Header /> : <Navbar />}
        <Box sx={styles.layoutContainer} id="main-component">
          <Switch>
            <Route path="/patients/add" component={AddPatient} />
            <Route
              path="/patients/:patientId/assessment/result/:assessmentId"
              component={AssessmentResult}
            />
            <Route
              path="/patients/:patientId/assessment/:assessmentId"
              component={Assessment}
            />
            <Route
              path="/patients/:patientId/assessment/result/:assessmentId/:accessToken"
              component={AssessmentResult}
            />
            <Route
              path="/patients/:patientId/assessment/"
              component={Assessment}
            />
            <Route
              path="/patients/:patientId/2/aboutassessment"
              component={AboutAssessment}
            />
            <Route
              path="/patients/:patientId/2/bodyareas"
              component={BodyAreas}
            />
            <Route
              path="/patients/:patientId/2/dentalstatus"
              component={DentalStatus}
            />
            <Route
              path="/patients/:patientId/2/globaljudgments"
              component={GlobalJudgments}
            />
            <Route
              path="/patients/:patientId/1"
              component={AssessmentHistory}
            />
            <Route
              path="/patients/:patientId/2"
              component={AssessmentHistory}
            />

            <Route path="*" component={Patient} />
          </Switch>
        </Box>

        {!showIsMobileWalkthroughDialog ? (
          isAssessmentScreen ? (
            <BottomBar />
          ) : (
            <Footer />
          )
        ) : (
          <></>
        )}
      </Box>
    </>
  );
}

export default AppLayout;
